import { api } from '@/lib/api/client'
import type ISystemUser from '@/types/SystemUser'

/** `GET /users/directory` — exige `users:directory:read`. Roster de identidade
 *  do tenant inteiro (nome, @username, role, active, avatar); NÃO é a rota de
 *  gestão (`GET /users`, atrás de `users:read`). */
export async function fetchSystemUsers(): Promise<ISystemUser[]> {
  const { data } = await api.get<ISystemUser[]>('/users/directory')
  return data
}
